module.exports = __webpack_public_path__ + "img/tooltip-head-new.95830c08.png";